import axios from 'axios'
import { jwtDecode } from "jwt-decode";

const hostName = process.env.NODE_ENV === 'production' ? 'https://qa-api.marinescu.xyz/' : 'https://qa-api.marinescu.xyz/' //'https://localhost:5000/'
const client = process.env.NODE_ENV === 'production' ? 'qa.marinescu.xyz' : 'qa.marinescu.xyz'
const secret = process.env.NODE_ENV === 'production' ? '5e1b874f-7296-4cab-bde4-4a6e646395c1' : '5e1b874f-7296-4cab-bde4-4a6e646395c1'
let crtAxios = axios.create({
    baseURL: hostName
});

export default {
    isLoggedIn() {
        try {
            let accessToken = localStorage.getItem('access_token');
            const claims = jwtDecode(accessToken);
            const expiration = new Date(claims.exp * 1000);
            const now = new Date();
            now.setSeconds(now.getSeconds() - 100);

            if (now > expiration) {
                return false;
            }
            return true;
        } catch  {
            return false;
        }
    },
    getRole() {
        try {
            let accessToken = localStorage.getItem('access_token');
            const claims = jwtDecode(accessToken);
            return claims["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        } 
        catch  {
            return null;
        }
    },
    getHost() {
        return hostName;
    },
    getOauthHeader() {
        let token = btoa(client + ':' + secret);
        return {
            "Authorization": "Basic " + token,
            'Content-Type': 'application/x-www-form-urlencoded',
            "Accept": "application/json"
        };
    },
    requestToken(input) {
        let header = this.getOauthHeader();

        let params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('scope', 'read');
        params.append('username', input.username);
        params.append('password', input.password);


        return crtAxios.post('api/token', 
        params.toString(),
        { 
            headers: header
        });
    },
    refreshToken() {
        let header = this.getOauthHeader();
        let refreshToken = localStorage.getItem("refresh_token");

        let params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('scope', 'read');
        params.append('refresh_token', refreshToken);

        return crtAxios.post('api/token', 
        params.toString(),
        { 
            headers: header
        });
    },
    async tryToLoggin() {
        let refreshToken = localStorage.getItem('refresh_token');
        let loggedIn = this.isLoggedIn();
        if(!loggedIn && refreshToken) {
            
            let request = this.refreshToken().then((response) => {
                localStorage.setItem('access_token', response.data.access_token);
                localStorage.setItem('refresh_token', response.data.refresh_token);
                loggedIn = true
            })
            .catch(() => {
                loggedIn = false;
            });
            await request;
        }
        
        return new Promise((resolve, reject) => {
            if(loggedIn)
                resolve({ })
            else 
                reject({ })
        });
    },
    deleteAccount(username, password) {
        let header = this.getOauthHeader();

        return crtAxios.post('api/delete-account', 
        { username: username, password: password },
        { 
            headers: header
        });
    }
}